import { useEffect } from 'react';
import { useTeamsClientSetup } from '../../../teams-wrapper/hooks/use-teams-client-setup';
import { useSetTeamsConfigActions } from '../../store/main';
export const useSetClientConfig = clientConfig => {
  const {
    setClientConfig
  } = useSetTeamsConfigActions();
  useTeamsClientSetup(clientConfig.stargateRoot, clientConfig.cloudId, clientConfig.orgId);
  useEffect(() => {
    setClientConfig(clientConfig);
  }, [setClientConfig, clientConfig]);
};